// Client and guest stay in the call only while the host is in the room.
// Leaving on purpose is a different screen from the host stepping out.

export function shouldWaitForHost({ role, leftIdentity, hostIdentity, intentional }) {
  if (intentional) return false
  if (role !== "client" && role !== "guest") return false
  if (!hostIdentity) return false
  return leftIdentity === hostIdentity
}
